import { createTrackingReportSlice } from "../../DealsTrackingReportPage/components/TrackingReportView/state";

export default createTrackingReportSlice("adminPanelTrackingReport");
